"use client";

import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";

const useWindowSearchParams = () => {
  const pathname = usePathname();
  const [searchParams, setSearchParams] = useState<URLSearchParams>(new URLSearchParams());

  useEffect(() => {
    const currentSearchParams = new URLSearchParams(window.location.search);
    setSearchParams(currentSearchParams);
  }, [pathname]);

  return searchParams;
};

export const useUpdateWindowSearchParams = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useWindowSearchParams();

  const updateSearchParam = (
    keyValues: { key: string; value: string | undefined }[],
    replace = false,
  ) => {
    const newSearchParams = new URLSearchParams(searchParams);
    keyValues.forEach(({ key, value }) => {
      if (value) {
        newSearchParams.set(key, value);
      } else {
        newSearchParams.delete(key);
      }
    });
    if (replace) {
      router.replace(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
    } else {
      router.push(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
    }
  };

  return updateSearchParam;
};

export default useWindowSearchParams;
